// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__0B-6g","image":"NotFound_image__ppIID","textHeading":"NotFound_textHeading__RYH3v"};